// src/lib/groupModeUtils.js

function toLocalDateString(date) {
  const d = new Date(date);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

export function getGroupModeForDate(groupModes, groupName, date) {
  if (!groupModes || !groupName || !date) return null;

  const targetDate = toLocalDateString(date);
  const modesForGroup = groupModes.filter(g => g.group_name === groupName);

  const modeForDate = modesForGroup.find(m => {
    const start = toLocalDateString(m.start_date);
    const end = m.end_date ? toLocalDateString(m.end_date) : start;
    return targetDate >= start && targetDate <= end;
  });

  return modeForDate ? modeForDate.mode : null;
}
